import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/CustomersDashboard.vue";
import SFDashboard from "../views/UsersDashboard.vue";
import SFADashboard from "../views/AccountsDashboard.vue";
import SFMDashboard from "../views/ManagerDashboard.vue";
import Tables from "../views/Tables.vue";
import Contracts from "../views/Contracts/Contracts.vue";
import Campaings from "../views/Contracts/Campaings.vue";
import Campaing from "../views/Contracts/Campaing.vue";
import SFContracts from "../views/Contracts/SFContracts.vue";
import SFAContracts from "../views/Contracts/SFAContracts.vue";
import SFMContracts from "../views/Contracts/SFMContracts.vue";
import Contract from "../views/Contracts/Contract.vue";
import Installs from "../views/Contracts/Installs.vue";
import NoInstalls from "../views/Contracts/NoInstalls.vue";
import SFInstalls from "../views/Contracts/SFInstalls.vue";
import SFANoInstalls from "../views/Contracts/SFANoInstalls.vue";
import SFAInstalls from "../views/Contracts/SFAInstalls.vue";
import SFNoInstalls from "../views/Contracts/SFNoInstalls.vue";
import SFMInstalls from "../views/Contracts/SFMInstalls.vue";
import SFMNoInstalls from "../views/Contracts/SFMNoInstalls.vue";
import Install from "../views/Contracts/Install.vue";
import Report from "../views/Contracts/Report.vue";
import SFReport from "../views/Contracts/SFReport.vue";
import SFAReport from "../views/Contracts/SFAReport.vue";
import SFMReport from "../views/Contracts/SFReport.vue";
import Cases from "../views/Contracts/Cases.vue";
import Billing from "../views/Billing.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import Users from "../views/Admin/Users.vue";
import User from "../views/Admin/User.vue";
import UProfile from "../views/Admin/Profile.vue";
const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/signin",
  },
  {
    path: "/dashboard",
    name: "Inicio",
    component: Dashboard,
  },
  {
    path:"/dashboard-sf",
    name: "Dashboard",
    component:SFDashboard
  },
  {
    path:"/dashboard-sfa",
    name: "Dashboard",
    component:SFADashboard
  },
  {
    path:"/dashboard-sfm",
    name: "Dashboard Manager",
    component:SFMDashboard
  },
  {
    path: "/contracts",
    name: "Contratos",
    component: Contracts,
  },
  {
    path: "/campaigns",
    name: "Ejecuciones",
    component: Campaings,
  },
  {
    path: "/campaign/:id",
    name: "Ejecucion",
    component: Campaing,
  },
  {
    path: "/contracts-sf",
    name: "Contratos por Ejecutivo",
    component: SFContracts,
  },
  {
    path: "/contracts-sfa",
    name: "Contratos por Cuenta",
    component: SFAContracts,
  },
  {
    path: "/contracts-sfm",
    name: "Contratos Global",
    component: SFMContracts,
  },
  {
    path: "/contract/:id",
    name: "Contrato",
    component: Contract,
  },
  {
    path: "/installs",
    name: "Instalaciones",
    component: Installs,
  },
  {
    path: "/noinstalls",
    name: "No Instalaciones",
    component: NoInstalls,
  },
  {
    path: "/installs-sf",
    name: "Instalaciones por Ejecutivo",
    component: SFInstalls,
  },
  {
    path: "/noinstalls-sf",
    name: "No Instalaciones por Ejecutivo",
    component: SFNoInstalls,
  },
  {
    path: "/installs-sfa",
    name: "Instalaciones por Cuenta",
    component: SFAInstalls,
  },
  {
    path: "/noinstalls-sfa",
    name: "No Instalaciones por Cuenta",
    component: SFANoInstalls,
  },
  {
    path: "/installs-sfm",
    name: "Instalaciones Global",
    component: SFMInstalls,
  },
  {
    path: "/noinstalls-sfm",
    name: "No Instalaciones Global",
    component: SFMNoInstalls,
  },
  {
    path: "/install/:id",
    name: "Instalación",
    component: Install,
  },
  {
    path: "/photo-report",
    name: "Reporte Fotográfico",
    component: Report,
  },
  {
    path: "/photo-report-sf",
    name: "Reporte Fotográfico Ejecutivo",
    component: SFReport,
  },
  {
    path: "/photo-report-sfa",
    name: "Reporte Fotográfico Cuenta",
    component: SFAReport,
  },
  {
    path: "/photo-report-sfm",
    name: "Reporte Fotográfico Global",
    component: SFMReport,
  },
  {
    path: "/users",
    name: "Usuarios",
    component: Users,
  },
  {
    path: "/my-profile",
    name: "Perfil",
    component: UProfile,
  },
  {
    path: "/user/:id",
    name: "Usuario",
    component: User,
  },
  {
    path: "/cases",
    name: "Casos",
    component: Cases,
  },
  {
    path: "/tables",
    name: "Tables",
    component: Tables,
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/signup/:id",
    name: "Signup",
    component: Signup,
  },
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
